/**
 * Confidence display utilities shared across verdict components.
 */

export interface ConfidenceDisplay {
  label: string;
  color: string;
  bgColor: string;
  icon: 'shield' | 'check' | 'warning';
}

/** Get confidence level label and color based on score (0-1) */
export function getConfidenceDisplay(score: number): ConfidenceDisplay {
  if (score >= 0.85) {
    return { label: 'High Confidence', color: 'text-emerald-400', bgColor: 'bg-emerald-400/10 border-emerald-400/30', icon: 'shield' };
  } else if (score >= 0.7) {
    return { label: 'Moderate Confidence', color: 'text-verdict-primary', bgColor: 'bg-verdict-primary/10 border-verdict-primary/30', icon: 'check' };
  } else if (score >= 0.5) {
    return { label: 'Low Confidence', color: 'text-amber-400', bgColor: 'bg-amber-400/10 border-amber-400/30', icon: 'warning' };
  } else {
    return { label: 'Uncertain', color: 'text-red-400', bgColor: 'bg-red-400/10 border-red-400/30', icon: 'warning' };
  }
}

/** Get a brief text hint explaining the confidence level */
export function getConfidenceHint(score: number): string {
  if (score >= 0.85) {
    return 'Multiple AI agents reached strong consensus with fact-checking verification.';
  } else if (score >= 0.7) {
    return 'Agents generally agree, with minor discrepancies resolved through debate.';
  } else if (score >= 0.5) {
    return 'Some disagreement among agents - review sources carefully.';
  } else {
    return 'Significant disagreement - treat this analysis with caution.';
  }
}
